export default function BackofficeHero() {
  return (
    <section className="bg-gradient-to-br from-slate-800 via-slate-700 to-slate-900 text-white py-20">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-white/10 rounded-full mb-6">
            <i className="ri-dashboard-line text-4xl"></i>
          </div>
          <h1 className="text-5xl font-bold mb-6">
            Welcome to Your Backoffice
          </h1>
          <p className="text-xl text-gray-200 mb-8 leading-relaxed">
            Your central hub for all the tools, resources, and support you need to succeed. 
            Access onboarding materials, explore toolkits, and manage your real estate business efficiently.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg px-6 py-4">
              <div className="text-3xl font-bold">50+</div>
              <div className="text-sm text-gray-300">Tools Available</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg px-6 py-4">
              <div className="text-3xl font-bold">24/7</div>
              <div className="text-sm text-gray-300">Support Access</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg px-6 py-4">
              <div className="text-3xl font-bold">100%</div>
              <div className="text-sm text-gray-300">Cloud-Based</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
